






import Signup from '@/web/components/signup/Signup.vue';

export default {
  name: 'StudioSignup',
  components: {
    Signup,
  },
};
